import { env } from '@/lib/config/env';

// Null outside production unless that environment names its own GA property.
const googleAnalyticsId = env.analytics.googleAnalyticsId;

export const siteConfig = {
  title: 'Auction Chase',
  description:
    'Experience real-time player auctions with live bidding, team management, and comprehensive tournament organization.',
  /** Without additional '/' on the end */
  url: 'https://www.auctionchase.com',
  company: {
    name: 'Auction Chase',
    // registration: 'DE123456789',
    /**
     * Operating address. Emitted in the Organization JSON-LD only — it is
     * deliberately not rendered anywhere in the UI. Kept because
     * payment-gateway compliance reviews (Razorpay's international-payments
     * enablement) look for a business address associated with the site.
     *
     * `city` is the minimum that makes an address publishable; `street` is
     * optional and drops out of the schema when blank. Clear `city` to drop
     * the address from the schema rather than publishing something partial
     * — see `hasCompanyAddress` below.
     */
    address: {
      street: '',
      city: 'Surat',
      state: 'Gujarat',
      postalCode: '395009',
      country: 'India',
    },
  },
  social: {
    twitter: 'auction_chase',
    facebook: 'auctionchasesports',
    instagram: 'auction_chase',
    linkedin: 'auction-chase',
    youtube: 'UC89JnvKmWZDAGGWnbm7tLGg',
  },
  contact: {
    email: 'support@auctionchase.com',
    phone: '+917990534319',
  },
  seo: {
    keywords: [
      // Primary Keywords
      'sports auction platform',
      'live sports auction platform',
      'tournament management system',
      'player auction platform',

      // Sports-Specific Keywords
      'cricket auction platform',
      'football player auction',
      'IPL style auction platform',
      'sports league auction system',

      // Feature-Specific Keywords
      'real-time sports bidding',
      'live auction management',
      'team budget management platform',
      'player draft system',

      // Long-tail Keywords
      'how to organize sports player auction',
      'best platform for cricket team auction',
      'sports tournament management platform',
      'live bidding system for sports teams',

      // Intent-based Keywords
      'create online sports auction',
      'manage sports team auction',
      'organize cricket tournament auction',
      'run football team auction',

      // Location-based Keywords
      'sports auction platform india',
      'cricket auction platform UAE',
      'tournament management system USA',
      'player auction platform UK',

      // Existing High-Performance Keywords
      'live ipl auction',
      'box cricket tournament',
      'turf cricket tournament',
      'fantasy sports auction',
      'sports league management',
      'live sports auction platform',
      'player draft management',
      'sports event management',
      'cricket auction live',
      'online player auction platform',
      'live player auction',

      // Problem-Solving Keywords
      'simplify sports team auction',
      'automate player bidding process',
      'streamline tournament management',
      'efficient team selection system',
    ],
  },
  analytics: {
    googleAnalyticsId,
    facebookPixelId: '734388102772188',
    hotjarId: 'XXXXXXX',
  },
  features: {
    enableBlog: true,
    enableNewsletter: true,
    enableTestimonials: true,
    enableShareButtons: true,
  },
};

/** True once a city is set, so a half-filled address never ships. */
export const hasCompanyAddress = siteConfig.company.address.city.length > 0;

export type SiteConfig = typeof siteConfig;
